var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.112,
    height: 8.885,
    viewBox: "0 0 7.112 8.885",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M321.722,185.577h-.436V184.31a2.66,2.66,0,0,0-5.32,0v1.268h-.436a.46.46,0,0,0-.46.46v4.037a.46.46,0,0,0,.46.46h6.192a.46.46,0,0,0,.46-.46v-4.037a.46.46,0,0,0-.46-.46Zm-4.638-1.268a1.543,1.543,0,1,1,3.085,0v1.268h-3.085Zm2.044,3.9v.825a.5.5,0,1,1-1,0v-.825a.808.808,0,1,1,1,0Z",
    transform: "translate(-315.07 -181.65)",
    fill: "#8b8f9c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.bbe95af4ffe0b18a7a919333d49b1dda.svg";
export { ForwardRef as ReactComponent };